import React from 'react'
import imgUrl from '../assets/images/imgUrl'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

function Home() {
  return (
    <div className='homeMainWrapper'>

        {/* home first section */}
        
        <div className='homeBackground'>
            <div className='upperImage'>
            <img src={imgUrl.smileLogo} alt='smile logo'></img>
            </div>
        </div>

        {/* doctor information */}

        <div className='doctorInfo'>
            <div className='doctorImage'>
              <img src={imgUrl.drhuzaifa} alt='Doctor Huzaifa'></img>
            </div>
             <Typography className='headings sectionHeading'>Dr. Huzaifa Khorakiwala</Typography>
               {/* <Link to="https://www.dr-huzaifa-khorakiwala.care" target='blank'><Typography className='websiteLink'>www.dr-huzaifa-khorakiwala.care</Typography></Link> */}
        </div>

        {/* global map */}
        
        <section>
        <div className='globalSection p-40px'>
               
              

            <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
            </div>
            <div style={{position:'relative'}}>
            <Typography className='paraTags titleOne'>Championing Peace, Healthcare and Humanitarian Values Globally.</Typography>
             <div className='birdGraphic'>
                  <img src={imgUrl.birdLeftside}></img>
               </div>
               </div>
            <Typography className='paraTags secondaryText'>This inspiring credo defines <b> Dr. Huzaifa Khorakiwala’s</b> life mission. As a mentor and global 
            humanitarian leader, <b> Dr. Khorakiwala</b> wears many hats – he is the Founder of a global  
           <b> I Am Peacekeeper Movement</b>, Executive Director of the Wockhardt healthcare conglomerate  
            and CEO of a major philanthropic Wockhardt Foundation.</Typography>
        </div>
        </section>

        {/* positions section */}

        <section>
            <div className='positionWrapper p-40px'>
                 <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
                </div>

                <Typography className='headings sectionHeading'>Positions</Typography>

            <Grid container spacing={2} className="d-flex-align-center-justify-center tabletGridview">

               

                <Grid size={{ xs: 12, md: 6 , lg:3}} className="partners d-flex-align-center-justify-center flex-direction-column">
                    <div className='logo wockhardt'>
                       <img src={imgUrl.lifewinsLogo}></img>
                    </div>

                    <Typography className='paraTags fw-bold font-italic '>Wockhardt</Typography>
                    <Typography className='paraTags fw-bold'>Executive Director,</Typography>
                    <Typography className='paraTags description'>Steering one of <b className='font-italic '>India’s</b> leading global pharmaceutical and biotechnology
                    companies with innovation and strategic vision.
                    </Typography>
                    
                </Grid>

                  <Grid size={{ xs: 12, md: 6 , lg:3}} className="partners positionInnergrid d-flex-align-center-justify-center flex-direction-column">
                    <div className='logo'>
                       <img src={imgUrl.jupiterLogo}></img>
                    </div>

                    <Typography className='paraTags fw-bold font-italic '>Jupiter Events LLC</Typography>
                    <Typography className='paraTags fw-bold'>Owner, </Typography>
                    <Typography className='paraTags description'>Guiding a <b className='font-italic '>Dubai</b> based umbrella organisation responsible for orchestrating
                    global event-related initiatives, including the <b className='font-italic '>Global Justice, Love & Peace
                    Summit,</b> the <b className='font-italic '>I Am Peacekeeper Movement</b> and <b className='font-italic '>Billionaires for Peace
                    Conclave,</b> with visionary leadership and strategic direction.
                    </Typography>
                    
                </Grid>

                 <Grid size={{ xs: 12, md: 6 , lg:3}} className="partners positionInnergrid d-flex-align-center-justify-center flex-direction-column">
                    <div className='logo'>
                       <img src={imgUrl.peacekeeperLogo}></img>
                    </div>

                    <Typography className='paraTags fw-bold font-italic '>I Am Peacekeeper Movement</Typography>
                    <Typography className='paraTags fw-bold'>Founder, </Typography>
                    <Typography className='paraTags description'>Leading a grassroots peace movement of over <b> 1.8 million I Am
                    Peacekeeper </b> globally, founded on <b> 7 core human values – Gratitude,
                    Forgiveness, Love, Humility, Giving, Patience and Truth.</b>
                    </Typography>
                    
                </Grid>

              

                
            </Grid>

            <Grid container spacing={2} className="mt-50px d-flex-align-center-justify-center tabletGridview">

                <Grid size={{ xs: 12, md: 6 , lg:3}} className="partners d-flex-align-center-justify-center flex-direction-column">
                    <div className='logo wockhardt'>
                       <img src={imgUrl.wockhardtLogo}></img>
                    </div>

                    <Typography className='paraTags fw-bold font-italic '>Wockhardt Foundation</Typography>
                    <Typography className='paraTags fw-bold'>CEO  </Typography>
                    <Typography className='paraTags description'>Spearheading a not-for-profit organisation that operates numerous social
                    service programmes focused on <b> health, education, water </b>  and <b> sanitation, </b> 
                    uplifting millions of lives every year. Over the past <b> 12 years, 40 million
                    underprivileged patients </b>   have benefited from primary healthcare services.
                    </Typography>
                    
                </Grid>
     
               <Grid size={{ xs: 12, md: 6 , lg:3}} className="partners positionInnergrid d-flex-align-center-justify-center flex-direction-column">
                    <div className='logo'>
                       <img src={imgUrl.globalJusticeLogo}></img>
                    </div>

                    <Typography className='paraTags fw-bold font-italic '>Global Justice, Love & Peace Summit</Typography>
                    <Typography className='paraTags fw-bold'>Chairman</Typography>
                    <Typography className='paraTags description ipadDescription'>Leading a grassroots peace movement of over <b> 1.8 million I Am
                    Peacekeeper </b> online globally, founded on <b> 7 core human values – Gratitude,
                    Forgiveness, Love, Humility, Giving, Patience and Truth.</b>
                    </Typography>
                    
                </Grid>

                 <Grid size={{ xs: 12, md: 6 , lg:3}} className="partners positionInnergrid d-flex-align-center-justify-center flex-direction-column ipadPeacegrid">
                    <div className='logo'>
                       <img src={imgUrl.nobelLogo}></img>
                    </div>

                    <Typography className='paraTags fw-bold font-italic '>Billionaires for Peace</Typography>
                    <Typography className='paraTags'>Chairman</Typography>
                    <Typography className='paraTags description lastPositionpara'>
                        Guiding a coalition of global philanthropists and visionaries aligned with
                        <b> Nobel-inspired humanitarian efforts </b>  to promote peace-building
                        worldwide.
                    </Typography>
                    
                </Grid>

            </Grid>

            <Grid container spacing={2} className="mt-50px d-flex-align-center-justify-center tabletGridview d-none">

                <Grid size={{ xs: 12, md: 6 , lg:3}} className="emptyGrid">
                </Grid>
     
               <Grid size={{ xs: 12, md: 6 , lg:3}} className="partners d-flex-align-center-justify-center flex-direction-column d-none">
                    <div className='logo'>
                       <img src={imgUrl.guineaBissauLogo}></img>
                    </div>

                    <Typography className='paraTags fw-bold'>Health Advisor</Typography>
                    <Typography className='paraTags fw-bold'>PM Guinea-Bissau</Typography>
                    <Typography className='paraTags description'>Providing expert healthcare guidance to support and enhance <b className='font-italic '> Guinea-Bissau’s </b> public health initiatives, extending a commitment to improving
                    lives globally through strategic advisory and impactful solutions.
                    </Typography>
                    
                </Grid>

                 <Grid size={{ xs: 12, md: 6 , lg:3}} className="emptyGrid">
                </Grid>

            </Grid>

            </div>
        </section>

        {/* dynamic banner section */}

        <section>
            <div className='dynamicBannerwrapper p-40px'>
               <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
                </div>

              {/* <Typography className='headings sectionHeading blackTitles'>Dynamic Banner</Typography> */}

              <Grid container spacing={2} className="mt-25px">
                <Grid size={{ xs: 12, sm:6, md: 6 , lg:3}}>
                    <Card className='bannerCards'>
                        <CardContent className='bannerCardcontent'>
                            <div className='borderRed'></div>
                            <Typography className='bannerCardtitles'>Historic Laureates <br />Summit</Typography>
                            <Typography className='secondaryText'><b>In April 2025,
                          Dr. Khorakiwala</b>   hosted <b> the Global Justice, Love &
                            Peace Summit </b>
                            in Dubai,
                            bringing together an
                            unprecedented <b>10 Nobel
                            Peace Laureates</b>  to advance
                            a charter for world peace.
                            </Typography>

                        </CardContent>
                    </Card>
                </Grid>

                <Grid size={{ xs: 12, sm:6, md: 6 , lg:3}}>
                    <Card className='bannerCards'>
                        <CardContent className='bannerCardcontent'>
                            <div className='borderRed'></div>
                            <Typography className='bannerCardtitles'>Healthcare for Millions</Typography>
                            <Typography className='secondaryText'>Under his leadership,
                           <b className='font-italic '> Wockhardt Foundation’s </b> 
                            flagship <b> Mobile 1000 </b> 
                            programme has delivered
                            free primary healthcare
                            to over <b> 40 million
                            underprivileged patients </b>
                            across rural <b> India </b>   over the
                            past <b> 12 years. </b>
                            </Typography>

                        </CardContent>
                    </Card>
                </Grid>

                <Grid size={{ xs: 12, sm:6, md: 6 , lg:3}}>
                    <Card className='bannerCards'>
                        <CardContent className='bannerCardcontent'>
                            <div className='borderRed'></div>
                            <Typography className='bannerCardtitles'>Join the I Am
                          <br />Peacekeeper Movement</Typography>
                            <Typography className='secondaryText'>Become part of the <b className='font-italic '>I
                            Am Peacekeeper Global
                           Movement.</b> Take the <b className='font-italic '> I
                            Am Peacekeeper  Pledge </b>
                            today and contribute to
                            the collective of peace
                            advocates living the <b> 7
                            Human Values. </b>
                            </Typography>

                        </CardContent>
                    </Card>
                </Grid>

                <Grid size={{ xs: 12, sm:6, md: 6 , lg:3}}>
                    <Card className='bannerCards'>
                        <CardContent className='bannerCardcontent'>
                            <div className='borderRed'></div>
                            <Typography className='bannerCardtitles'>Global Recognition</Typography>
                            <Typography className='secondaryText'>Dr Khorakiwala’s
                            contributions have earned
                            him <b>110 awards,</b>  including
                            a <b>Knighthood, 15 Honorary
                            Doctorates, 2 D.Litt.
                            degrees</b> and the title <b> Man of
                            the Year 2025.</b>
                            </Typography>

                        </CardContent>
                    </Card>
                </Grid>

              </Grid>


            </div>
        </section>
        
    </div>
  )
}

export default Home
